var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClientAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.791 0 12 1.791 12 4C12 6.209 13.791 8 16 8C18.209 8 20 6.209 20 4C20 1.791 18.209 0 16 0ZM5 8C4.68957 8.00124 4.38121 8.05066 4.08594 8.14648L0 9.10742V16.3086L4 15L12.1562 17.8535C12.8083 18.0815 13.5267 18.0272 14.1367 17.7012L20.2676 14.4238C20.9386 14.0648 21.2107 13.2437 20.8887 12.5547C20.5557 11.8427 19.7111 11.5314 18.9961 11.8594L13.0859 14.5703L12.7129 14.082L13.0078 13.4277C13.4628 12.4127 13.0024 11.2194 11.9824 10.7754L6.23047 8.26758C6.19562 8.25128 6.16045 8.23565 6.125 8.2207C5.76767 8.0755 5.3857 8.00056 5 8Z",
    fill: "#FFFCEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClientAccount);
export default __webpack_public_path__ + "static/media/ic_client_account.086c65887378a3c21d912d683620f925.svg";
export { ForwardRef as ReactComponent };